import cx from "classnames";
import React from "react";
import { Button as ReactstrapButton } from "reactstrap";
import { Icon } from "./Icon/Icon";
import type { IconName } from "./Icon/iconNames";
import type { SpinnerSize } from "./Spinner";
import { SPINNER_SIZES, Spinner } from "./Spinner";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: string;
  color?: string;
  icon?: IconName;
  active?: boolean;
  disabled?: boolean;
  classNames?: string;
  isLoading?: boolean;
  spinnerSize?: SpinnerSize;
  square?: boolean;
  children?: React.ReactNode;
  iconClassName?: string;
  outline?: boolean;
};

export const Button = React.memo(
  ({
    size = "md",
    color = "primary",
    icon,
    disabled = false,
    classNames = "",
    isLoading = false,
    spinnerSize = SPINNER_SIZES.XS,
    square = false,
    children,
    iconClassName,
    ...rest
  }: ButtonProps) => (
    <div className="position-relative m-0 p-0">
      <ReactstrapButton
        size={size}
        disabled={disabled || isLoading}
        color={color}
        className={cx(
          "d-flex align-items-center justify-content-center user-select-none",
          classNames,
          {
            "btn-square": square,
            "btn-close": color === "close",
            "w-100": size === "lg",
          },
        )}
        {...rest}
      >
        {isLoading && (
          <div
            className="position-absolute py-1"
            style={{
              top: "50%",
              transform: "translate(50%, -50%)",
              right: "50%",
            }}
          >
            <Spinner
              className="loader pt-0"
              data-testid="button-spinner"
              size={spinnerSize}
              color={color === "primary" ? "white" : "primary"}
            />
          </div>
        )}
        {icon && <Icon iconName={icon} className={iconClassName || "me-2"} />}
        {children}
      </ReactstrapButton>
    </div>
  ),
);
